module.exports = __webpack_public_path__ + "8f8d719554664ef3e93a1bb2574cef8b.svg";